import { FilterOption } from "../../../../models";
import { RequestFilterModelType } from "../../../../services";
import { PDLAccordion, PDLTypography } from "../../dna";
import FiltrosItem from "../_filtrosItem";

interface FiltrosListaProps {
  items: FilterOption[];
  onPeriodChange: (value: any) => void;
  period: any;
  isModelTypeFilterList?: boolean;
  modelType?: RequestFilterModelType;
}

const FiltrosLista = ({
  items = [],
  onPeriodChange,
  period,
  isModelTypeFilterList = false,
  modelType,
}: FiltrosListaProps) => {
  return (
    <PDLAccordion flush>
      {items?.map(({ id, label, options, type }, index) => (
        <FiltrosItem
          key={`filtros-item-${id}`}
          title={
            <PDLTypography size="sm" weight="semibold" className="py-1">
              {label}
            </PDLTypography>
          }
          options={options || []}
          id={id}
          type={type}
          index={index}
          onPeriodChange={onPeriodChange}
          period={period}
          isModelTypeFilterItem={isModelTypeFilterList}
          modelType={modelType}
        />
      ))}
    </PDLAccordion>
  );
};

export default FiltrosLista;
